






























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { Event } from '@/models/event';
import allColors from '@/plugins/colors.json';

import EventInfoSiteTemplate from './EventInfoSiteTemplate.vue';
import ImageSelect from './ImageSelect.vue';
import SliderColor from './SliderColor.vue';
import toast from './toast';
import { ToastType } from './toast/tost-type.enum';

@Component({
  components: {
    EventInfoSiteTemplate,
    ImageSelect,
    SliderColor,
  },
})
export default class StepSiteComponent extends Vue {
  @Prop({ required: true })
  private event!: Event & { siteTemplate?: any };

  private allColorsToSlider = allColors.map(({ hex }) => hex);

  async onEditImage({ imageBase64 }: { imageBase64: string }) {
    try {
      this.event.attachImage(imageBase64);
      toast('Imagem carregada', ToastType.SUCESS);
    } catch (err) {
      toast('Erro ao carregar imagem', ToastType.ERROR);
    }
  }

  mounted() {
    this.event.siteTemplate = this.event.siteTemplate || {};
    this.changeStepBackground();
  }

  onColorChange(palette: Array<string>) {
    this.event.siteTemplate = this.event.siteTemplate || {};
    this.event.siteTemplate.palette = palette;
    this.changeStepBackground();
  }

  changeStepBackground() {
    if (!this.event.siteTemplate || !this.event.siteTemplate.palette) {
      return;
    }
    const elm: HTMLElement = document.querySelector('.step-site-content');
    elm.classList.add('color-changed');
    elm.style.background = `linear-gradient(${this.event.siteTemplate.palette.join(',')})`;
  }

  @Emit()
  onUpdate(event: Event) {
    return event;
  }
}
